<div class="row">
	@for (field of controls | keyvalue: this.keyvaluePipeCompareFn; track
	field.key; let idx = $index) {
	<div
		class="align-self-top"
		[class]="getBsClass(handleBaseInputProp(field.value, 'size'))"
		[class.align-self-center]="field.value.inputType === 'checkbox'"
	>
		@if (field.value.inputType === 'fieldset') {

		<app-fieldset-input
			[control]="handleFieldsetInputType(field.value)"
			[controlId]="field.key"
			[filter]="filter"
			[form]="form"
		>
		</app-fieldset-input>
		} @else {

		<app-form-input
			[field]="handleBaseInputType( field.value)"
			[filter]="filter"
			[form]="form"
			[name]="idx +'-'+field.key"
		></app-form-input>
		}
	</div>
	}
</div>
